import _ from "lodash";
import type { Annotation } from "@rapid/types/annotation";
import type { PromptLabel } from "@rapid/store/slices/modelIntentSlice";
import type { InferenceStrategyConfig } from "./types";
import { SAM3_INFERENCE_CONFIDENCE_THRESHOLD } from "@rapid/utils/predictions";

/**
 * Inference strategy for the Build flow.
 *
 * Build flow uses Rapid inference with all text prompts and any available box prompts.
 * The backend combines SAM3 text prompting with OWLv2 + SAM2 box prompting.
 */
export class BuildFlowStrategy implements InferenceStrategyConfig {
    getSam3Labels(promptLabels: Map<string, PromptLabel>, textPrompts: string[]): string[] {
        return _.uniq([...Array.from(promptLabels.keys()), ...textPrompts]);
    }

    getOwlv2Labels(promptLabels: Map<string, PromptLabel>): string[] {
        return Array.from(promptLabels.keys());
    }

    shouldAppendPredictions(_isMixedInference: boolean): boolean {
        return false;
    }

    getBoxPromptingAnnotations(
        allAnnotationsForLabel: Annotation[],
        _currentFileAnnotations: Annotation[]
    ): Annotation[] {
        // Build flow uses ALL annotations across all files
        return allAnnotationsForLabel;
    }

    shouldIncludeImageUrls(): boolean {
        // Build flow uses storage lookup with signed URLs
        return false;
    }

    getTextPromptConfidenceThreshold(): number {
        return SAM3_INFERENCE_CONFIDENCE_THRESHOLD;
    }
}
